import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Emitter } from "strict-event-emitter";

export default class TabSwitch extends ComponentBase
{
  emitter: Emitter<{click: [newIndex: number]}>

  private _selectedIndex: number;
  private _autoSwitch: boolean = true;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();
    
    let tabArray = this.$root.find(".tab").toArray();

    tabArray.forEach((elem: HTMLElement, index: number)=>
    {      
      if(elem.getAttribute("selected") === "true")
      {
        this._selectedIndex = index;
      }

      $(elem).on("click", (event:JQuery.ClickEvent)=>
      {
        event.preventDefault();
        
        if(index !== this._selectedIndex)
        {
          this.emitter.emit("click", index);
        }

        if(this._autoSwitch)
        {
          this.toIndex(index);
        }
      });
    });

    if(this._selectedIndex === undefined)
    {
      this.$root.find(".tab")[0].setAttribute("selected", "true");
      this._selectedIndex = 0;
    }
  }

  setAutoSwitch(b: boolean)
  {
    this._autoSwitch = b;
  }

  toIndex(index: number)
  {        
    if(index === this._selectedIndex) return;
    this._selectedIndex = index;

    let $tabs = this.$root.find(".tab");
    $tabs.attr("selected", "false");

    $tabs[this._selectedIndex].setAttribute("selected", "true");
    
    this.emitter.emit("click", index);
  }
}